import 'intersection-observer';

import Vue from 'vue'
import config from '@/config'
import {CONF_REQ_PROPS, CONF_IDLE_TIME, CONF_WS_URL, LANG} from '@/constants';
// import './pollyfills'
// @ts-ignore
import store from './store'
import VueRouter from 'vue-router'
// import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
// import lang from 'element-ui/lib/locale/lang/en'
// @ts-ignore
import localeRu from 'element-ui/lib/locale/lang/ru-RU'
// @ts-ignore
import localeEn from 'element-ui/lib/locale/lang/en'
// @ts-ignore
import localeTr from 'element-ui/lib/locale/lang/tr-TR'
// @ts-ignore
import localeKz from '@/lang/kz/locale'
// @ts-ignore
import localeCn from 'element-ui/lib/locale/lang/zh-CN'
// @ts-ignore
import localeUz from '@/lang/uz/locale';
// @ts-ignore
import localeIn from '@/lang/in/locale';
// @ts-ignore
import localeEs from 'element-ui/lib/locale/lang/es';
// @ts-ignore
import App from './App.vue'
// @ts-ignore
import bus from './services/bus'
// @ts-ignore

// Plugins
// @ts-ignore
import GlobalComponents from './gloablComponents'
// @ts-ignore
import GlobalDirectives from './globalDirectives'
// @ts-ignore
import GlobalFilters from './globalFilters'
// @ts-ignore
import SideBar from './components/SidebarPlugin'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// @ts-ignore
import IdleVue from 'idle-vue'
// @ts-ignore
import VueClipboard from 'vue-clipboard2'
// @ts-ignore
import VueTruncate from 'vue-truncate-filter'
// @ts-ignore
import YmapPlugin from 'vue-yandex-maps'
// @ts-ignore
import Sticky from 'vue-sticky-directive'
import moment from 'moment'
// @ts-ignore
import vueMoment from 'vue-moment'
import {lang} from '@/lang/index';

import VueI18n from 'vue-i18n';
// @ts-ignore
import i18nEn from './lang/en/index';
import i18nRu from './lang/ru/index';
import i18nTr from './lang/tr/index';
import i18nUz from './lang/uz/index';
import i18nKz from './lang/kz/index';
import i18nCn from './lang/cn/index';
import i18nIn from './lang/in/index';
import i18nEs from './lang/es/index';

// @ts-ignore
import Cookies from 'js-cookie'

// router setup
import router from './routes'

// @ts-ignore
import sidebarLinks from './sidebarLinks'
// @ts-ignore
import localStorageTransport from './services/localStorageTransport'

import VueObserveVisibility from 'vue-observe-visibility'

import {routerHistory} from '@/plugins/router-history'
import './plugins/resizeDetector'
// @ts-ignore
import tabsSidebar from 'src/plugins/tabs-sidebar'
import capitalizer from 'src/plugins/capitalizer'
import declin from 'src/plugins/declin'
// @ts-ignore
import VDragged from 'v-dragged'
// @ts-ignore
// import vOutsideEvents from 'vue-outside-events'

// @ts-ignore
import {Plugin} from 'vue-fragment';

import LDError from '@/services/errors'

import emojiPlugin from 'src/plugins/emoji'

import Ws from '@/services/ws'
import globvars from '@/lib/globvars'
import notifyHandler from '@/services/notifyHandler'
import {RawNotify} from '@/types/entity/RawNotify'
import _ from 'lodash'

import device from 'vue-device-detector';
// @ts-ignore
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';

import 'moment/locale/ru'
import 'moment/locale/tr'
import 'moment/locale/kk'
import 'moment/locale/zh-cn'
import 'moment/locale/uz'
import 'moment/locale/es'
import 'moment/locale/pa-in'
import 'moment/locale/en-gb'
import VueMeta from 'vue-meta';

Vue.use(device);
Vue.use(Donut);

async function logExternal (data: any) {
  try {
    store.dispatch('logExternal', data)
  } catch (error) {
    console.log('LOG: name -> error', error)
  }
}


function appInit () {
  const websock = new Ws(config(CONF_WS_URL), function (data: RawNotify) {
    console.log('Notify', data)
    notifyHandler(_.cloneDeep(data))
  })

  globvars.set('ws', websock)
  Vue.use(emojiPlugin);
  Vue.use(Plugin);
  Vue.use(VueMeta);
  Vue.use(capitalizer)
  Vue.use(declin)
  Vue.use(VDragged)
  Vue.use(VueObserveVisibility)
  Vue.use(vueMoment, {moment})
  // Vue sticky
  Vue.use(Sticky)
  Vue.directive('sticky', Sticky)

  Vue.use(localStorageTransport)

  // plugin setup
  Vue.use(VueI18n)
  Vue.use(tabsSidebar)
  Vue.use(VueRouter)
  Vue.use(routerHistory)

  const Lang = Cookies.get('lang_checked') || config(LANG) || 'en';
  let locale;

  if (Lang === 'ru') {
    locale = localeRu;
  } else if (Lang === 'tr') {
    locale = localeTr;
  } else if (Lang === 'uz') {
    locale = localeUz;
  } else if (Lang === 'in') {
    locale = localeIn;
  } else if (Lang === 'kz') {
    locale = localeKz;
  } else if (Lang === 'cn') {
    locale = localeCn;
  } else if (Lang === 'es') {
    locale = localeEs;
  } else {
    locale = localeEn;
  }

  Vue.use(ElementUI, {locale})
  Vue.use(GlobalDirectives)
  Vue.use(GlobalComponents)
  Vue.use(GlobalFilters)
  // Vue.use(vOutsideEvents)
  // Vue.use(VueNotify)
  Vue.use(SideBar, {sidebarLinks})
  Vue.use(VeeValidate, {
    validity: false
  })

  const events = ['mousemove', 'keydown', 'mousedown', 'touchstart']
  Vue.use(IdleVue, {
    eventEmitter: new Vue(),
    idleTime: config(CONF_IDLE_TIME),
    events: events.concat(['keepalive'])
  })

  // @ts-ignore
  localStorageTransport.on('keepalive', (time) => {
    // @ts-ignore
    window.dispatchEvent(new CustomEvent('keepalive', {time}))
  })
  events.forEach((event) => {
    window.addEventListener(event, () => {
      localStorageTransport.emit('keepalive', (new Date()).getTime())
    })
  })

  Vue.use(VueClipboard)
  Vue.use(VueTruncate)
  Vue.use(YmapPlugin)

  Vue.prototype.$bus = bus

  window.onerror = function (message, source, line, column, error) {
    const data = LDError(error, 'JSError')
  }
  if (process.env.NODE_ENV === 'production') {
    Vue.config.errorHandler = function (err, vm, info) {
      const data = LDError(err, 'JSError', {info})
      const error = {
        level: 'WARN',
        message: `ADMIN-UI ERROR: ${data.error.message}`,
        data: {ui_app: 'ADMIN-UI', ...data.ctx}
      }
      logExternal(error);
    }

    window.onerror = function (message, source, line, column, error) {
      const data = LDError(error, 'JSError')
    }
  }

  const messages = {
    en: {...i18nEn},
    ru: {...i18nRu},
    tr: {...i18nTr},
    kz: {...i18nKz},
    cn: {...i18nCn},
    uz: {...i18nUz},
    in: {...i18nIn},
    es: {...i18nEs}
  }

  const i18n = new VueI18n({
    locale: Lang,
    // @ts-ignore
    messages
  })

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    render: h => h(App),
    router,
    i18n,
    store
  })
}

(async function () {
  try {
    let response = await fetch('/config.json');
    let config = await response.json();
    for (const prop of CONF_REQ_PROPS) {
      if (!config[prop]) {
        alert(`appConfig property: "${prop}" not found!`)
        throw new Error(`appConfig property: "${prop}" not found!`);
      }
    }
    window.appConfig = config;

    if (!Cookies.get('lang')) {
      const defaultLang = config[LANG] || 'en';
      Cookies.set('lang', defaultLang);
    }

    Object.freeze(window.appConfig);
    appInit();
  } catch (error) {
    alert('appConfig not found!')
    console.error('appConfig not found!', {error, config: window.appConfig})
    window.stop();
  }
})();